import { seoSegmentationListingPage_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_jobSearchResults_seoSegmentationJob as SEOJob } from '@/__generated__/seoSegmentationListingPage';
import { JOB_TYPES } from '@/constants';
import { formatStartDate } from '@/utils/formatStartDate';

export interface JobTagListProps {
  type: SEOJob['type'];
  hourlyRateRange: SEOJob['job']['hourlyRateRange'];
  startDate: SEOJob['job']['startDate'];
  city: SEOJob['city'];
  state: SEOJob['state'];
}

/**
 * Creates an array of job tags from job information.
 *
 * @param {object} params - The job information parameters
 * @param {string} [params.type] - The job type identifier that will be mapped to a display name via JOB_TYPES
 * @param {object} [params.hourlyRateRange] - The hourly rate range information
 * @param {string|Date} [params.startDate] - The job start date
 * @param {string} [params.city] - The city where the job is located
 * @param {string} [params.state] - The state where the job is located
 * @returns {string[]} An array of non-null job tag strings
 */
export const createJobTagList = ({
  type,
  hourlyRateRange,
  startDate,
  city,
  state,
}: JobTagListProps) => {
  const hourlyRateRangeText = `$${hourlyRateRange?.hourlyRateFrom?.amount} - $${hourlyRateRange?.hourlyRateTo?.amount}/hr`;
  const startDateFormatted = formatStartDate(startDate);

  return [
    type ? `${JOB_TYPES[type]}` : null,
    hourlyRateRange?.hourlyRateFrom?.amount && hourlyRateRange?.hourlyRateTo?.amount
      ? hourlyRateRangeText
      : null,
    startDate ? `starts ${startDateFormatted.month} ${startDateFormatted.day}` : null,
    city && state ? `${city}, ${state}` : null,
  ].filter((item): item is NonNullable<string> => item !== null);
};
